import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { MdOutlineClose } from "react-icons/md";
import { primaryFIxed } from "../../ui-elements/button";
import { useDispatch, useSelector } from "react-redux";
import {
  backToHomePage,
  changePopUpStatus,
  selectBackToHomePage,
  selectIsOpenModal,
  selectRequestStatus,
  selectStayInThatPage,
  setRequestStatus,
  stayInThatPage,
  selectPopUpEmail,
} from "../../redux/slices/popUp/popUpSlice";
import {
  changeStatus,
  closeModal,
  selectModalStatus,
} from "../../redux/slices/loginModal/modalSlice";
import { navigateTo } from "../../utils/navigationUtils";
import { useNavigate } from "react-router-dom";

const PopUpWindow = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const isOpenPopUp = useSelector(selectIsOpenModal);
  const requestData = useSelector(selectRequestStatus);
  const isSignIn = useSelector(selectModalStatus);
  const isBackToHome = useSelector(selectBackToHomePage);
  const stayInThatPageState = useSelector(selectStayInThatPage);
  const email = useSelector(selectPopUpEmail);

  const isSuccess = requestData?.status ?? false;
  const title = requestData?.title || "";
  const description = requestData?.description || "";

  const handleCLose = () => {
    dispatch(changePopUpStatus(false));
    dispatch(setRequestStatus(null));

    if (
      (isSignIn === "SignIn" && requestData?.status === false) ||
      stayInThatPageState
    ) {
      dispatch(stayInThatPage(false));
      return null;
    }

    if (isBackToHome) {
      setTimeout(() => {
        navigateTo(navigate, "");
        dispatch(backToHomePage(false));
      }, 8000);
    }

    dispatch(closeModal(false));
    dispatch(changeStatus(""));
  };

  const getMailProviderUrl = (email) => {
    if (!email) return null;

    const domain = email.split("@")[1]?.toLowerCase();

    if (domain.includes("gmail")) return "https://mail.google.com";
    if (domain.includes("yandex")) return "https://mail.yandex.com";
    if (domain.includes("mail.ru")) return "https://mail.ru";

    return "https://mail.google.com";
  };

  const mailUrl = getMailProviderUrl(email);

  useEffect(() => {
    if (isOpenPopUp) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }

    return () => {
      document.body.classList.remove("modal-open");
    };
  }, [isOpenPopUp]);

  if (!isOpenPopUp) return null;

  return (
    <div className="fixed inset-0 flex justify-center items-center bg-[#000] bg-opacity-70 z-50">
      <div className="bg-white dark:bg-secondary_black shadow-md rounded-lg w-11/12 max-w-lg md:w-[500px] relative z-10">
        <button
          onClick={handleCLose}
          className="absolute top-2 right-2 p-2 text-black dark:text-white hover:text-gray-800 focus:outline-none"
        >
          <MdOutlineClose className="w-6 h-6" />
        </button>

        <div className="flex flex-col justify-between items-center py-8 px-2">
          {isSuccess ? (
            <svg width="50" height="50" viewBox="0 0 50 50" fill="none">
              <path
                d="M17.2 29.2L31.3 15.1L28.5 12.3L17.2 23.6L11.5 17.9L8.7 20.7L17.2 29.2Z"
                fill="#34B349"
              />
            </svg>
          ) : (
            <svg width="50" height="50" viewBox="0 0 50 50" fill="none">
              <circle cx="20" cy="20" r="18" fill="#F02934" />
              <path
                d="M14 14L26 26M26 14L14 26"
                stroke="white"
                strokeWidth="3"
                strokeLinecap="round"
              />
            </svg>
          )}

          <h2 className="font-[500] text-[30px] text-black dark:text-white pt-4 text-center">
            {t(title)}
          </h2>

          <p className="text-[18px] text-a070 dark:text-[#cbcbcb]  pt-2 pb-5 text-center">
            {t(description)}
          </p>

          {isSuccess && mailUrl ? (
            <a
              href={mailUrl}
              target="_blank"
              rel="noopener noreferrer"
              className={primaryFIxed}
              onClick={handleCLose}
            >
              {t("goToMailbox")}
            </a>
          ) : (
            <button className={primaryFIxed} onClick={handleCLose}>
              {t("ok")}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default PopUpWindow;
